import { Component } from '@angular/core';
import { MapConsentService } from './shared/map-consent.service';

@Component({
  selector: 'avs-map-consent',
  templateUrl: './map-consent.component.html',
  styleUrls: ['./map-consent.component.css']
})
export class MapConsentComponent {

    constructor(private readonly mapConsentService: MapConsentService) {}

    public onAcceptButtonClicked(): void {
        this.mapConsentService.grantConsent();
    }
}